package com.downdogapp.client.api

import kotlin.js.JsName

/**
 * AUTO-GENERATED DO NOT EDIT!
 * from com.downdogapp.tasks.api.json.enums.ClientEnumsFile
 */
// @formatter:off
enum class AppType {
  @JsName("ORIGINAL") ORIGINAL,
  @JsName("PILATES") PILATES,
  @JsName("MEDITATION") MEDITATION,
  @JsName("HIIT") HIIT,
  @JsName("BARRE") BARRE,
  @JsName("PRENATAL") PRENATAL,
  @JsName("RUNNING") RUNNING,
  @JsName("BREATHING") BREATHING,
  @JsName("INTRO") INTRO,
  @JsName("SEVEN") SEVEN
}

enum class BoostType {
  @JsName("STRENGTH") STRENGTH,
  @JsName("STRETCHES") STRETCHES
}

enum class ChallengeInterval {
  @JsName("DAY") DAY,
  @JsName("WEEK") WEEK,
  @JsName("MONTH") MONTH
}

enum class FeedbackType {
  @JsName("ACCOUNT_AND_LOGIN_ISSUES") ACCOUNT_AND_LOGIN_ISSUES,
  @JsName("AFFORDABILITY") AFFORDABILITY,
  @JsName("FREE_FOR_SCHOOLS") FREE_FOR_SCHOOLS,
  @JsName("BILLING") BILLING,
  @JsName("TECH_ISSUES") TECH_ISSUES,
  @JsName("FEATURE_REQUEST") FEATURE_REQUEST,
  @JsName("EXERCISE_ADVICE") EXERCISE_ADVICE,
  @JsName("PRACTICE_FEEDBACK") PRACTICE_FEEDBACK,
  @JsName("OTHER") OTHER
}

enum class Language {
  @JsName("ENGLISH") ENGLISH,
  @JsName("SPANISH") SPANISH,
  @JsName("PORTUGUESE") PORTUGUESE,
  @JsName("FRENCH") FRENCH,
  @JsName("GERMAN") GERMAN,
  @JsName("ITALIAN") ITALIAN,
  @JsName("RUSSIAN") RUSSIAN,
  @JsName("MANDARIN") MANDARIN,
  @JsName("JAPANESE") JAPANESE,
  @JsName("KOREAN") KOREAN,
  @JsName("TURKISH") TURKISH,
  @JsName("POLISH") POLISH,
  @JsName("UKRAINIAN") UKRAINIAN
}

enum class LinkType {
  @JsName("MENU") MENU,
  @JsName("MESSAGE") MESSAGE,
  @JsName("PLAY_STORE") PLAY_STORE,
  @JsName("ITUNES") ITUNES,
  @JsName("SPOTIFY") SPOTIFY,
  @JsName("AMAZON") AMAZON,
  @JsName("PUSH_NOTIFICATION") PUSH_NOTIFICATION
}

enum class LoginResponseType {
  @JsName("SUCCESS") SUCCESS,
  @JsName("ERROR") ERROR,
  @JsName("WRONG_PASSWORD") WRONG_PASSWORD,
  @JsName("SIGN_UP") SIGN_UP
}

enum class MembershipType {
  @JsName("APPLE") APPLE,
  @JsName("GOOGLE") GOOGLE,
  @JsName("STRIPE") STRIPE,
  @JsName("PAYPAL") PAYPAL
}

enum class ProductPeriod {
  @JsName("MONTHLY") MONTHLY,
  @JsName("YEARLY") YEARLY
}

enum class RegenType {
  @JsName("INIT") INIT,
  @JsName("REWIND") REWIND,
  @JsName("SKIP") SKIP,
  @JsName("CHANGE_TYPE") CHANGE_TYPE,
  @JsName("AUDIO_BALANCE") AUDIO_BALANCE
}

enum class SignInReason {
  @JsName("PURCHASE") PURCHASE,
  @JsName("REFERRAL") REFERRAL,
  @JsName("GIFT_PURCHASE") GIFT_PURCHASE,
  @JsName("GIFT_REDEMPTION") GIFT_REDEMPTION,
  @JsName("CHALLENGE_ENROLLMENT") CHALLENGE_ENROLLMENT,
  @JsName("SUPPORT") SUPPORT,
  @JsName("PLAYBACK") PLAYBACK
}

enum class SongFeedback {
  @JsName("THUMBS_UP") THUMBS_UP,
  @JsName("THUMBS_DOWN") THUMBS_DOWN,
  @JsName("NONE") NONE
}

enum class TrackerActivityType {
  @JsName("YOGA") YOGA,
  @JsName("HIIT") HIIT,
  @JsName("BARRE") BARRE,
  @JsName("RUNNING") RUNNING,
  @JsName("MEDITATION") MEDITATION,
  @JsName("PILATES") PILATES
}

enum class WorkoutType {
  @JsName("YOGA") YOGA,
  @JsName("HIIT") HIIT,
  @JsName("MEDITATION") MEDITATION,
  @JsName("BARRE") BARRE,
  @JsName("PILATES") PILATES
}
